export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11221.b974d4a9.jpg";